import { render } from "./audio_control.vue?vue&type=template&id=47f0f744"
import script from "./audio_control.vue?vue&type=script&lang=js"
export * from "./audio_control.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/control/audio_control.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47f0f744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47f0f744', __exports__)) {
    api.reload('47f0f744', __exports__)
  }
  
  module.hot.accept("./audio_control.vue?vue&type=template&id=47f0f744", () => {
    api.rerender('47f0f744', render)
  })

}


export default __exports__